export type FirebaseOperation = 'read' | 'write' | 'findAll' | 'findOne' | 'findById' | 'create' | 'update' | 'patch' | 'delete';

export const FIREBASE_OPERATIONS: FirebaseOperation[] = ['read', 'write', 'findAll', 'findOne', 'findById', 'create', 'update', 'patch', 'delete'];
